/**
 * Mobile tap: first tap shows alternate image, second tap follows product link.
 */
(function () {
  'use strict';

  var activeTrigger = null;

  function isFinePointer() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function clearActive() {
    if (!activeTrigger) return;
    activeTrigger.classList.remove('is-alt-visible');
    activeTrigger = null;
  }

  function hasAltImage(trigger) {
    return !!(trigger && trigger.querySelector('.vrv-img-hover__alt'));
  }

  document.addEventListener(
    'touchstart',
    function (e) {
      if (isFinePointer()) return;
      if (e.target.closest('button, [data-wishlist-btn], [class*="wishlist"], [data-variant-id], .luxury-add-to-bag, [class*="add-to-cart"], [class*="overlay-add-to-bag"]')) {
        return;
      }

      var link = e.target.closest('.vrv-img-hover__link');
      var trigger = link && link.closest('.vrv-img-hover-trigger');
      if (!trigger || !hasAltImage(trigger)) {
        clearActive();
        return;
      }

      if (activeTrigger === trigger) {
        clearActive();
        return;
      }

      clearActive();
      trigger.classList.add('is-alt-visible');
      activeTrigger = trigger;
    },
    { passive: false }
  );

  document.addEventListener('click', function (e) {
    if (!activeTrigger || isFinePointer()) return;
    if (e.target.closest('.vrv-img-hover-trigger') === activeTrigger) return;
    clearActive();
  });

  document.addEventListener('scroll', clearActive, { passive: true });
})();
